(function () {
  'use strict';

  function init() {
    if (!document.body || !document.body.classList.contains('pm-provider-easysell')) return;

    var labels = window.PmEasySellLabels || {};
    var frame = 0;
    var modalWasOpen = false;
    var lastTrigger = null;
    var productOrderSession = null;
    var replayingProductClick = false;
    var closingModal = false;

    function cartJson(url, payload) {
      var options = {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      };
      if (payload !== undefined) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
      }
      return fetch(url, options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'cart_request');
          return data;
        });
      });
    }

    function snapshotLines(cart) {
      return (cart.items || []).map(function (item) {
        var line = {
          id: Number(item.variant_id),
          quantity: Number(item.quantity),
          properties: item.properties || {},
        };
        var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        if (sellingPlan && sellingPlan.id) line.selling_plan = sellingPlan.id;
        return line;
      });
    }

    function refreshCartUi() {
      return Promise.all([
        cartJson('/cart.js'),
        fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then(function (response) {
          if (!response.ok) throw new Error('cart_sections');
          return response.json();
        }),
      ]).then(function (results) {
        var cart = results[0];
        var sections = results[1];
        var bubbleSource = sections['cart-icon-bubble']
          ? new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble')
          : null;
        var bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubbleSource && bubbleTarget) bubbleTarget.innerHTML = bubbleSource.innerHTML;

        var drawer = document.querySelector('cart-drawer');
        var drawerSource = sections['cart-drawer']
          ? new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner')
          : null;
        var drawerTarget = drawer && drawer.querySelector('.drawer__inner');
        if (drawerSource && drawerTarget) {
          drawerTarget.innerHTML = drawerSource.innerHTML;
          drawer.classList.toggle('is-empty', cart.item_count === 0);
        }
        return cart;
      });
    }

    function replaceCart(snapshot) {
      return cartJson('/cart/clear.js', {})
        .then(function () {
          if (!snapshot.lines.length) return null;
          return cartJson('/cart/add.js', { items: snapshot.lines });
        })
        .then(function () {
          return cartJson('/cart/update.js', {
            note: snapshot.note || '',
            attributes: snapshot.attributes || {},
          });
        });
    }

    function restoreProductCart() {
      if (!productOrderSession) return Promise.resolve();
      if (productOrderSession.restorePromise) return productOrderSession.restorePromise;
      var session = productOrderSession;
      session.restorePromise = replaceCart(session.snapshot)
        .catch(function () { return replaceCart(session.snapshot); })
        .then(refreshCartUi)
        .then(function (cart) {
          if (productOrderSession === session) productOrderSession = null;
          session.trigger.removeAttribute('aria-busy');
          session.trigger.classList.remove('loading');
          return cart;
        })
        .catch(function (error) {
          session.restorePromise = null;
          session.trigger.removeAttribute('aria-busy');
          session.trigger.classList.remove('loading');
          var product = session.trigger.closest('[data-pm-product-section]');
          var message = product && product.querySelector('#PmOptionMessage');
          if (message) {
            message.classList.remove('is-quiet');
            message.textContent = 'Votre panier n’a pas pu être restauré. Actualisez la page avant de continuer.';
          }
          throw error;
        });
      return session.restorePromise;
    }

    function beginProtectedProductOrder(trigger) {
      trigger.setAttribute('aria-busy', 'true');
      trigger.classList.add('loading');
      return cartJson('/cart.js')
        .then(function (cart) {
          productOrderSession = {
            trigger: trigger,
            modalSeen: false,
            restorePromise: null,
            snapshot: {
              lines: snapshotLines(cart),
              note: cart.note,
              attributes: cart.attributes,
            },
          };
          replayingProductClick = true;
          trigger.click();
          replayingProductClick = false;
          window.setTimeout(function () {
            if (productOrderSession && !productOrderSession.modalSeen) restoreProductCart().catch(function () {});
          }, 8000);
        })
        .catch(function () {
          replayingProductClick = false;
          trigger.removeAttribute('aria-busy');
          trigger.classList.remove('loading');
          var product = trigger.closest('[data-pm-product-section]');
          var message = product && product.querySelector('#PmOptionMessage');
          if (message) {
            message.classList.remove('is-quiet');
            message.textContent = 'Impossible de préparer la commande. Actualisez la page puis réessayez.';
          }
        });
    }

    function isPresent(selector, scope) {
      return Boolean((scope || document).querySelector(selector));
    }

    function setLabel(selector, value, scope) {
      var element = (scope || document).querySelector(selector);
      if (!element || !value) return;
      var textNode = Array.prototype.find.call(element.childNodes, function (node) { return node.nodeType === 3; });
      if (textNode) textNode.nodeValue = value + ' ';
      else element.insertBefore(document.createTextNode(value + ' '), element.firstChild);
    }

    function setImportantStyles(element, styles) {
      if (!element) return;
      Object.keys(styles).forEach(function (property) {
        var value = styles[property];
        if (element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') return;
        element.style.setProperty(property, value, 'important');
      });
    }

    function isModalOpen(modal) {
      return Boolean(modal && window.getComputedStyle(modal).display !== 'none');
    }

    function releasePageScroll() {
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }

    function finishClosingModal(modal) {
      if (!modal || !isModalOpen(modal)) {
        closingModal = false;
        releasePageScroll();
        scheduleRefresh();
        return;
      }

      modal.style.setProperty('display', 'none');
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('pm-es-modal-active');
      closingModal = false;
      releasePageScroll();
      scheduleRefresh();
    }

    function closeEasySellModal(modal) {
      if (!modal || closingModal) return;
      closingModal = true;

      var nativeClose = modal.querySelector(
        '.close-icon:not(.pm-es-close), [data-bs-dismiss="modal"], [data-dismiss="modal"]'
      );
      if (nativeClose) nativeClose.click();

      window.requestAnimationFrame(function () {
        finishClosingModal(modal);
      });
    }

    function enhanceModal(modal) {
      if (!modal) return null;

      var content = modal.querySelector('.es-modal-content') || modal.querySelector('#easysell');
      if (!content) return null;

      var close = content.querySelector('.pm-es-close');
      if (!close) {
        close = document.createElement('button');
        close.type = 'button';
        close.className = 'pm-es-close';
        close.setAttribute('aria-label', labels.close || 'Fermer');
        close.innerHTML = '<span aria-hidden="true">&times;</span>';
        close.addEventListener('click', function () { closeEasySellModal(modal); });
        content.insertBefore(close, content.firstChild);
      }

      if (!modal.dataset.pmCloseReady) {
        modal.dataset.pmCloseReady = 'true';
        modal.addEventListener('click', function (event) {
          /* EasySell sometimes adds an extra full-screen wrapper inside the
             overlay. Treat every click outside the actual dialog as a close. */
          if (!content.contains(event.target)) closeEasySellModal(modal);
        });
      }

      return close;
    }

    function translateForm(modal) {
      var form = modal && modal.querySelector('#es-form');
      if (!form) return;

      var heading = form.querySelector('.es-form-header .mb-2');
      if (heading && labels.modalTitle) heading.textContent = labels.modalTitle;

      setImportantStyles(modal.querySelector('#es-form-container'), {
        color: 'var(--pm-es-text-color)',
        background: 'linear-gradient(180deg, var(--pm-es-surface-color) 0%, var(--pm-es-surface-soft-color) 100%)',
        border: '1px solid color-mix(in srgb, var(--pm-es-accent-color) 58%, transparent)',
        'border-radius': 'var(--pm-es-modal-radius)',
      });

      setImportantStyles(heading, {
        color: 'var(--pm-es-text-color)',
        'font-family': 'var(--ff-head)',
        'font-size': 'clamp(23px, 4.5vw, 28px)',
        'font-weight': '600',
        'line-height': '1.1',
        'letter-spacing': '-.02em',
      });

      var intro = form.querySelector('.pm-es-intro');
      if (!intro && labels.modalIntro) {
        intro = document.createElement('p');
        intro.className = 'pm-es-intro';
        intro.textContent = labels.modalIntro;
        form.querySelector('.es-form-header').insertAdjacentElement('afterend', intro);
      }

      [
        ['#es-first_name', labels.name, labels.namePlaceholder, 'name'],
        ['#es-phone', labels.phone, labels.phonePlaceholder, 'tel'],
        ['#es-address', labels.address, labels.addressPlaceholder, 'street-address'],
        ['#es-zip', labels.zip, labels.zipPlaceholder, 'postal-code'],
        ['#es-city', labels.city, labels.cityPlaceholder, 'address-level2'],
      ].forEach(function (field) {
        var input = form.querySelector(field[0]);
        if (!input) return;
        setLabel('label[for="' + input.id + '"]', field[1], form);
        if (field[2]) input.placeholder = field[2];
        if (field[3]) input.autocomplete = field[3];
      });

      setLabel('label[for="es-province"]', labels.region, form);
      var provincePlaceholder = form.querySelector('#es-province option[value=""]');
      if (provincePlaceholder && labels.regionPlaceholder) provincePlaceholder.textContent = labels.regionPlaceholder;

      var marketing = form.querySelector('.es-checkbox-label');
      var marketingInput = form.querySelector('.es-buyer_accepts_marketing-group input[type="checkbox"]');
      if (marketing && labels.marketing) marketing.textContent = labels.marketing;
      if (marketingInput && marketing) {
        marketingInput.id = 'PmEasySellMarketing';
        marketing.setAttribute('for', marketingInput.id);
      }

      var subtotal = form.querySelector('.es-subt-line .label-title');
      var shipping = form.querySelector('.es-shipping-line .label-title');
      var free = form.querySelector('.es-shipping-line .label-value span');
      var total = form.querySelector('.es-total-line > div:first-child');
      if (subtotal && labels.subtotal) subtotal.textContent = labels.subtotal;
      if (shipping && labels.shipping) shipping.textContent = labels.shipping;
      if (free && labels.free) free.textContent = labels.free;
      if (total && labels.total) total.textContent = labels.total;

      var submitText = form.querySelector('#es-form-button .es-button-content > div:last-child > span');
      if (submitText && labels.submit) {
        var submitNode = Array.prototype.find.call(submitText.childNodes, function (node) { return node.nodeType === 3; });
        if (submitNode) submitNode.nodeValue = labels.submit + ' — ';
      }

      /* EasySell injects inline !important colors after the theme stylesheet.
         Keep the override, but point it at editable theme variables. */
      var submitButton = form.querySelector('#es-form-button');
      if (submitButton) {
        setImportantStyles(submitButton, {
          'min-height': '56px',
          padding: '12px 20px',
          border: '1.5px solid var(--pm-es-button-color)',
          'border-radius': '100px',
          background: 'var(--pm-es-button-color)',
          color: 'var(--pm-es-button-text-color)',
          'box-shadow': '0 14px 30px -20px rgba(23, 23, 19, .72)',
          'font-family': 'var(--ff-body)',
          'font-size': '16px',
          'font-weight': '700',
          'letter-spacing': '.025em',
          'line-height': '1.15',
        });
        submitButton.querySelectorAll('.es-button-content, .es-button-content *').forEach(function (element) {
          setImportantStyles(element, { color: 'var(--pm-es-button-text-color)' });
        });
        setImportantStyles(submitButton.querySelector('.es-button-subtitle'), {
          'font-size': '11px',
          'font-weight': '600',
          'letter-spacing': '.02em',
          opacity: '.78',
        });
      }

      var close = form.querySelector('.close-icon');
      if (close) {
        close.setAttribute('role', 'button');
        close.tabIndex = 0;
        close.setAttribute('aria-label', labels.close || 'Fermer');
      }
    }

    function refresh() {
      frame = 0;

      document.querySelectorAll('.es-popup-button').forEach(function (button) {
        if (button.tagName !== 'BUTTON') {
          button.setAttribute('role', 'button');
          button.tabIndex = 0;
        }
        if (!button.getAttribute('aria-label')) {
          button.setAttribute('aria-label', labels.orderButton || 'Commander maintenant');
        }
      });

      document.querySelectorAll('.es-popup-button-drawer, .es-popup-button-cart').forEach(function (button) {
        var title = button.querySelector('.es-button-title');
        if (title && labels.cartButton) title.textContent = labels.cartButton;
        if (labels.cartButton) button.setAttribute('aria-label', labels.cartButton);
        setImportantStyles(button, {
          'min-height': '58px',
          padding: '10px 15px',
          border: '1px solid rgba(186, 173, 131, .68)',
          'border-radius': '16px',
          background: 'linear-gradient(135deg, #1c1a15 0%, #080807 72%)',
          color: '#ffffff',
          'box-shadow': 'inset 0 1px 0 rgba(255, 255, 255, .08), 0 16px 32px -22px rgba(18, 18, 18, .85)',
          'font-family': 'var(--ff-body)',
          'font-size': '14px',
          'font-weight': '700',
          'letter-spacing': '.035em',
        });
        setImportantStyles(button.querySelector('.bi'), {
          display: 'inline-grid',
          'place-items': 'center',
          width: '32px',
          height: '32px',
          'margin-right': '9px',
          border: '1px solid rgba(213, 201, 159, .6)',
          'border-radius': '50%',
          background: 'rgba(186, 173, 131, .12)',
          color: '#d5c99f',
          'font-size': '13px',
        });
      });

      document.querySelectorAll('#es-sticky, .es-sticky').forEach(function (sticky) {
        sticky.setAttribute('aria-hidden', 'true');
        sticky.setAttribute('inert', '');
      });

      document.querySelectorAll('[data-pm-product-section]').forEach(function (product) {
        var button = product.querySelector('.es-popup-button-product, #es-popup-button.es-popup-button-product');
        var ready = Boolean(button);
        var variantInput = product.querySelector('.product-variant-id');
        var variantReady = Boolean(variantInput && !variantInput.disabled && variantInput.value);
        product.classList.toggle('pm-easysell-ready', ready);
        product.classList.toggle('pm-easysell-variant-ready', variantReady);

        if (button) {
          var title = button.querySelector('.es-button-title');
          if (title && !button.dataset.pmOriginalTitle) button.dataset.pmOriginalTitle = title.textContent.trim();
          if (variantReady) {
            button.removeAttribute('aria-disabled');
            if (title && labels.orderButton) title.textContent = labels.orderButton;
          } else {
            button.setAttribute('aria-disabled', 'true');
            if (title && title.textContent !== (labels.chooseSize || 'Choisir une pointure pour commander')) {
              title.textContent = labels.chooseSize || 'Choisir une pointure pour commander';
            }
          }
          setImportantStyles(button, {
            'min-height': '58px',
            padding: '10px 15px',
            border: '1px solid rgba(186, 173, 131, .68)',
            'border-radius': '16px',
            background: 'linear-gradient(135deg, #1c1a15 0%, #080807 72%)',
            color: '#ffffff',
            'box-shadow': 'inset 0 1px 0 rgba(255, 255, 255, .08), 0 16px 32px -22px rgba(18, 18, 18, .85)',
            'font-family': 'var(--ff-body)',
            'font-size': '14px',
            'font-weight': '700',
            'letter-spacing': '.035em',
          });
          setImportantStyles(button.querySelector('.bi'), {
            display: 'inline-grid',
            'place-items': 'center',
            width: '32px',
            height: '32px',
            'margin-right': '9px',
            border: '1px solid rgba(213, 201, 159, .6)',
            'border-radius': '50%',
            background: 'rgba(186, 173, 131, .12)',
            color: '#d5c99f',
            'font-size': '13px',
          });
        }
      });

      document.body.classList.toggle('pm-easysell-cart-ready', isPresent('.es-popup-button-cart'));
      document.body.classList.toggle('pm-easysell-drawer-ready', isPresent('.es-popup-button-drawer'));

      var modal = document.getElementById('easysell-modal');
      var modalOpen = isModalOpen(modal);
      document.body.classList.toggle('pm-easysell-modal-open', modalOpen);
      if (modal) {
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', labels.dialogLabel || 'Formulaire de commande à la livraison');
        modal.classList.toggle('pm-es-modal-active', modalOpen);
        if (modalOpen) modal.removeAttribute('aria-hidden');
        else modal.setAttribute('aria-hidden', 'true');
        translateForm(modal);
      }
      if (modalOpen && modal) {
        var closeButton = enhanceModal(modal);
        if (!modalWasOpen) {
          var scrollArea = modal.querySelector('.es-modal-content');
          window.requestAnimationFrame(function () {
            if (scrollArea) scrollArea.scrollTop = 0;
            if (closeButton) closeButton.focus({ preventScroll: true });
          });
        }
      }
      if (productOrderSession && modalOpen) {
        productOrderSession.modalSeen = true;
        var confirmationText = modal.textContent || '';
        if (/merci|thank you|commande\s+confirm|order\s+confirm/i.test(confirmationText)) {
          restoreProductCart().catch(function () {});
        }
      }
      if (productOrderSession && productOrderSession.modalSeen && !modalOpen) {
        restoreProductCart().catch(function () {});
      }
      if (!modalOpen && modalWasOpen && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      modalWasOpen = modalOpen;
    }

    function scheduleRefresh() {
      if (frame) return;
      frame = window.requestAnimationFrame(refresh);
    }

    var observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    document.addEventListener('shopify:section:load', scheduleRefresh);
    function focusMissingVariant(product) {
      var group = Array.prototype.find.call(product.querySelectorAll('.pm-product__option'), function (option) {
        return !option.querySelector('input:checked');
      });
      if (!group) return;
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      group.classList.add('needs-attention');
      window.setTimeout(function () { group.classList.remove('needs-attention'); }, 1400);
      var choice = group.querySelector('input:not(:disabled)');
      if (choice) choice.focus({ preventScroll: true });
      var message = product.querySelector('#PmOptionMessage');
      if (message) {
        message.classList.remove('is-quiet');
        message.textContent = 'Choisissez votre pointure pour continuer.';
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.es-popup-button, .es-sticky');
      var product = trigger && trigger.matches('.es-popup-button-product')
        ? trigger.closest('[data-pm-product-section]')
        : null;
      if (product && !product.classList.contains('pm-easysell-variant-ready')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        focusMissingVariant(product);
        return;
      }
      if (product && !replayingProductClick) {
        event.preventDefault();
        event.stopImmediatePropagation();
        lastTrigger = trigger;
        beginProtectedProductOrder(trigger);
        return;
      }
      if (trigger) lastTrigger = trigger;
      scheduleRefresh();
      window.setTimeout(scheduleRefresh, 60);
    }, true);
    document.addEventListener('keydown', function (event) {
      var openModal = document.getElementById('easysell-modal');
      if (event.key === 'Escape' && isModalOpen(openModal)) {
        event.preventDefault();
        closeEasySellModal(openModal);
        return;
      }
      var close = event.target.closest('.close-icon[role="button"]');
      if (close && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        close.click();
        return;
      }
      var trigger = event.target.closest('.es-popup-button[role="button"]');
      if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      lastTrigger = trigger;
      trigger.click();
    });
    document.addEventListener('change', scheduleRefresh, true);
    window.addEventListener('load', scheduleRefresh);
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
